module.exports = __webpack_public_path__ + "img/ALFALogoNPS - Lite.5e02bcde.png";